<script>
export default {
	name: 'PhotoModal',
	props: ['post'],
	data() {
		return {
			isModalOpen: true,
			currentIndex: 0,
			photos: this.post.slider_images.map((image) => image.image_url),
		}
	},
	methods: {
		nextSlide() {
			this.currentIndex = (this.currentIndex + 1) % this.photos.length
		},
		prevSlide() {
			this.currentIndex = (this.currentIndex - 1 + this.photos.length) % this.photos.length
		},
	},
	watch: {
		isModalOpen(val) {
			document.body.style.overflow = val ? 'hidden' : ''
		},
	},
}
</script>

<template>
	<v-dialog persistent v-model="isModalOpen" max-width="100vw" max-height="100vh" fullscreen>
		<v-card class="modal-container d-flex justify-center align-center">
			<button type="button" class="close-btn" @click="$emit('close')">
				<Icon type="close" color="#002855" :size="20" />
			</button>
			<img class="full-screen-image" :src="photos[currentIndex]" alt="thread image" />
			<button type="button" v-if="photos.length > 1" class="prev-btn" @click="prevSlide">
				<v-icon style="color: #002855">mdi-chevron-left</v-icon>
			</button>
			<button type="button" v-if="photos.length > 1" class="next-btn" @click="nextSlide">
				<v-icon style="color: #002855">mdi-chevron-right</v-icon>
			</button>
		</v-card>
	</v-dialog>
</template>

<style scoped>
.modal-container {
	background-color: black;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	scroll-behavior: unset;
}

.full-screen-image {
	max-width: 80%;
	max-height: 80vh;
	object-fit: contain;
	border-radius: 8px !important;
}

.close-btn {
	position: absolute;
	top: 20px;
	right: 20px;
	width: 40px;
	height: 40px;
	background-color: #e2e2e2;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 8px !important;
	cursor: pointer;
	z-index: 1;
}

.prev-btn,
.next-btn {
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #ffffff;
	width: 40px;
	height: 40px;
	position: absolute;
	border-radius: 8px !important;
	top: 50%;
	transform: translateY(-50%);
	font-size: 36px;
	cursor: pointer;
	padding: 8px;
	transition: background 0.3s ease-in-out;
}

.prev-btn {
	left: 20px;
}

.next-btn {
	right: 20px;
}
::v-deep .v-dialog__content {
	border-radius: 0 !important;
}

::v-deep .v-sheet.v-card {
	border-radius: 0 !important;
}
</style>
